import Joi from 'joi';

export const EmailValidationPayloadSchema = Joi.object({
  desiredPackageId: Joi.string(),
  recaptchaToken: Joi.string(),
  email: Joi.string(),
});

export const EmailValidationSchema = Joi.object({
  message_en: Joi.string(),
  msg: Joi.string(),
  template: Joi.string(),
  url: Joi.string(),
  id: Joi.number(),
  params: Joi.array().items(Joi.string()),
  existingUser: Joi.boolean(),
  statusCode: Joi.number(),
  message: Joi.array().items(Joi.string()),
});

export const SocialLoginPayloadSchema = Joi.object({
  desiredPackageId: Joi.string(),
  type: Joi.string().required(),
  data: Joi.object({
    token: Joi.string(),
    userId: Joi.string(),
  }),
});

export const SocialLoginSchema = Joi.object({
  url: Joi.string(),
  message_en: Joi.string(),
  existingUser: Joi.boolean(),
  id: Joi.number(),
});

export const PackageInfoSchema = Joi.object({
  getStartedText: Joi.string(),
  id: Joi.number(),
  gettingStartedMediaUrl: Joi.string(),
  enableSocialLoginFlow: Joi.boolean()
});
